module.exports = __webpack_public_path__ + "static/media/hamantash4.bebdeadf.png";